/**
 * Author：brand
 * Creation Time：2019-08-28 16:03
 * Email：brandhuang@qq.com
 */
import * as utils from '@/utils/utils'

let WSC_URL = process.env.VUE_APP_WSC_URL

export function initWebSocket (param) {
  let chatsData = param.chats // 会话数据
  let shakeHandsDataType = 'clientlogin' // ws握手数据type类型
  let messagesHistory = ''
  let messagesId = ''
  let currentVisitorID
  for (let i in chatsData) {
    currentVisitorID = i
    messagesHistory = chatsData[i].messages_history
    messagesId = chatsData[i].messages_id
  }
  // 创建websocket连接
  const ws = new WebSocket(WSC_URL + '?from_uid=' + param.client_uid)
  // 连接成功
  ws.onopen = () => {
    // 发送握手数据
    let shakeHhandsData = {
      type: shakeHandsDataType,
      role: 'client',
      agent_uid: param.agent_uid,
      company_id: param.company_id,
      r_id: param.r_id,
      client_uid: param.client_uid,
      client_nickname: param.client_nickname,
      calling_no: param.calling_no,
      messages_history: messagesHistory,
      messages_id: messagesId,
      consult: param.consult,
      consultLink:param.consultLink
    }
    ws.send(JSON.stringify({ clientlogin: { message: shakeHhandsData } }))
  }
  // 接收到websocket推送
  ws.onmessage = (res) => {
    let resData = JSON.parse(res.data)
    let type = JSON.parse(res.data).type
    switch (type) {
      case 'ping':
        let tmpMsgs = window.vm.$store.state.messages
        // let tmpMsgs = chatsData[currentVisitorID].messages
        let lastMsg = tmpMsgs[tmpMsgs.length - 1]
        ws.send(JSON.stringify({
          pong: {
            message: {
              type: 'pong',
              role: lastMsg ? lastMsg.role : '',
              sendtime: lastMsg ? lastMsg.sendtime : ''
            }
          }
        }))
        break
      // 登录
      case 'login':
        for (let uid in resData.data.chats) {
          let loginChatMsg = resData.data.chats[uid]
          if (loginChatMsg.messages.length > 0) {
            loginChatMsg.messages.map(item => {
              window.vm.$store.dispatch('_updateMsg', item)
            })
          }
          window.vm.$store.dispatch('_loginSuccess', new Date())
        }
        break
      //  收发消息
      case 'say':
        for (let uid in resData.data) {
          let sayChatMsg
          if (resData.status === 3) { // status为3，转接人工时客服不在线，跳转留言
            sayChatMsg = {
              'sendtime': resData.data[uid].sendtime,
              'role': 'event',
              'text': resData.data[uid].text + '<span class="manual " style="color: #3396fb;padding-left: 5px;cursor: pointer;font-size: 13px"><span class="js_to_leaveMsg">去留言</span></span>'
            }
          } else if (resData.status === 2) { // status为2时，需要转接人工
            if (resData.is_manual_switch === 0) { // 自动转人工
              sayChatMsg = {
                'type': 'say',
                'sendtime': resData.data[uid].sendtime,
                'agent_avatar': resData.data[uid].agent_avatar,
                'agent_nickname': resData.data[uid].agent_nickname,
                'role': 'agent',
                'msg_type': 'text',
                'text': resData.data[uid].text
              }
              // 触发自动转人工
              window.vm.$store.dispatch('_autoTurnManual', new Date().getTime())
            } else if (resData.is_manual_switch === 1) { // 手动转人工
              sayChatMsg = {
                'type': 'say',
                'sendtime': resData.data[uid].sendtime,
                'agent_avatar': resData.data[uid].agent_avatar,
                'agent_nickname': resData.data[uid].agent_nickname,
                'role': 'agent',
                'msg_type': 'text',
                'text': resData.data[uid].text + `<span class="manual "><span class="js_manual">转人工</span></span>`
              }
            }
          } else {
            if (resData.isSystemMsg === 0) { // 0是机器人回复消息
              let text = resData.data[uid].text
              let relateProblems = resData.relateProblems
              let div = document.createElement('div')
              let ul = document.createElement('div')
              if(relateProblems.length){
                let p = document.createElement('p')
                p.innerHTML = resData.problemGuideText || ''
                p.setAttribute('class', 'problem-tips')
                p.style.marginTop = "8px"
                div.appendChild(p)
              }
              div.setAttribute('class', 'problem-container')
              ul.setAttribute('class', 'problem-list')
              for (let i = 0; i < relateProblems.length; i++) {
                let li = document.createElement('div')
                li.setAttribute('class', 'problem-item j-send-problem')
                li.innerHTML = relateProblems[i].standardProblem
                ul.appendChild(li)
              }
              div.appendChild(ul)
              let tmpNode = document.createElement('div')
              tmpNode.appendChild(div)
              let str = tmpNode.innerHTML
              str = text + str
              tmpNode = div = null // 解除引用，以便于垃圾回收
              sayChatMsg = {
                'type': 'say',
                'sendtime': resData.data[uid].sendtime,
                'agent_avatar': resData.data[uid].agent_avatar,
                'agent_nickname': resData.data[uid].agent_nickname,
                'role': 'agent',
                'msg_type': 'text',
                'to_uid': resData.data[uid].to_uid,
                'msg_status': '1',
                'callingId': resData.data[uid].callingId,
                'isSysMsg': 'notSysMsg',
                'text': str,
                'handler': '<p class=\'js_settled\' data-callingId=\'' + resData.data[uid].callingId + '\' data-visitId=\'' + resData.data[uid].to_uid + '\'>已解决</p><p' +
                  ' class=\'js_no_settled\' data-callingId=\'' + resData.data[uid].callingId + '\' data-visitId=\'' + resData.data[uid].to_uid + '\'>未解决</p>'
              }
            } else if (resData.isSystemMsg === 1) { // 1是系统消息
              sayChatMsg = {
                'type': 'say',
                'sendtime': resData.data[uid].sendtime,
                'agent_avatar': resData.data[uid].agent_avatar,
                'agent_nickname': resData.data[uid].agent_nickname,
                'role': 'agent',
                'msg_type': 'text',
                'text': resData.data[uid].text
              }
            } else { // 正常的消息
              sayChatMsg = resData.data[uid]
            }
          }
          ws.send(JSON.stringify({
            'sayback': {
              'message': {
                'from_uid': resData.data[uid].from_uid,
                'role': 'client',
                'to_uid': resData.data[uid].to_uid,
                'callingId': resData.data[uid].callingId || ''
              }
            }
          }))
          // resData.data[uid].callingId?sayChatMsg.callingId = resData.data[uid].callingId : ''
          sayChatMsg.libType = resData.libType
          window.vm.$store.dispatch('_updateMsg', sayChatMsg)
          window.vm.$store.dispatch('_sayMsg', new Date().getTime())
        }
        break
      // 消息撤回
      case 'revoke':
        for (let uid in resData.data) {
          let revokeChatMsg = resData.data[uid]
          // let chatMessages =  window.vm.$store.state.messages
          window.vm.$store.dispatch('_revokeMsg', revokeChatMsg)
        }
        break
      // 客服转接
      case 'switching':
        for (let uid in resData.data) {
          let switchingMsg = resData.data[uid]
          switchingMsg.text = switchingMsg.text.replace(/<[^>]+>/g, '').replace(/&nbsp;/ig, '')
          window.vm.$store.dispatch('_switchingMsg', switchingMsg)
          window.vm.$store.dispatch('_updateMsg', switchingMsg)
          window.vm.$store.dispatch('_sayMsg', new Date().getTime())
        }
        break
      // 会话关闭
      case 'close':
        for (let uid in resData.data) {
          let closeChatMsg = resData.data[uid]
          if (closeChatMsg.text && closeChatMsg.text.trim().length > 0) {
            window.vm.$store.dispatch('_updateMsg', closeChatMsg)
          }
          window.vm.$store.dispatch('_chatClose', true)
        }
        ws.close()
        ws.onclose = null
        break
      // 评价邀请
      case 'inviteEvaluation':
        window.vm.$store.dispatch('_inviteEvaluation', resData)
        break
      // 加入黑名单
      case 'blackclose':
        window.vm.$store.dispatch('_blackClose', true)
        ws.onclose = null
        break
      // 客服退出
      case 'agentlogout':
        for (let agentUid in resData.data) {
          param.agent_uid = agentUid
        }
        setTimeout(function () {
          initWebSocket(param)
        }, 100)
        break
      // 常用问题
      case 'commomProblem':
        let commomProblem = resData.data
        let div = document.createElement('div')
        let ul = document.createElement('div')
        let p = document.createElement('p')
        p.innerHTML = '你可能想问以下问题：'
        p.setAttribute('class', 'problem-tips')
        div.appendChild(p)
        div.setAttribute('class', 'problem-container')
        ul.setAttribute('class', 'problem-list')
        for (let i = 0; i < commomProblem.length; i++) {
          let li = document.createElement('div')
          li.setAttribute('class', 'problem-item j-send-problem')
          li.innerHTML = commomProblem[i].standardProblem
          ul.appendChild(li)
        }
        div.appendChild(ul)
        let tmpNode = document.createElement('div')
        tmpNode.appendChild(div)
        let str = tmpNode.innerHTML
        tmpNode = div = null // 解除引用，以便于垃圾回收
        let commomProblemMsg = {
          'type': 'say',
          'sendtime': resData.sendtime,
          'agent_avatar': resData.agent_avatar,
          'agent_nickname': resData.agent_nickname,
          'role': 'agent',
          'msg_type': 'text',
          'msg_status': '1',
          'isSysMsg': 'notSysMsg',
          'text': str
        }
        window.vm.$store.dispatch('_updateMsg', commomProblemMsg)
        break
      // 更新排队数量
      case 'updateQueueNum':
        window.vm.$store.dispatch('_updateQueuueNum',resData.data.frontNum)
        break
      // 排队结束
      case 'waitend':
        let params = {
          cid: window.vm.$cookie.get('cid'),
          uniquecode: window.vm.$cookie.get('FENBOT_fingerprint'),
          toid: window.vm.$utils.GetQueryString('toid'),
          csid: window.vm.$utils.GetQueryString('csid'),
          uid: window.vm.$utils.GetQueryString('uid'),
          type: window.vm.$utils.GetQueryString('type'),
          source: window.vm.$utils.GetQueryString('source')
        }
        ws.close()
        eventBus.$emit('waitend')
        window.vm.$store.dispatch('_login', params, resData.data.clientId)
        // window.vm.$store.dispatch('_changeLineupStatus', false)
        break
      // 已读未读
      case 'haveReadUnread':
        console.log(resData)
        break
    }
  }
  // ws 关闭或者断开
  ws.onclose = () => {
    ws.close()
    // setTimeout(function () {
    //   initWebSocket(param)
    // }, 500)
  }
  // ws发生错误
  ws.onerror = () => {
  }

  return ws
}
